<template>
    <div class="dianBox" @click="selectBtn" :class="{ active: !!(selectType == 1), unActive: !!(selectType == -1) }">
        <div class="dianActive"></div>
    </div>
</template>

<script>
export default {
    name: 'selectCircle',
    props: ['selectType'], // 状态：-1.不可选，0.未选中，1.已选中
    data() {
        return {}
    },
    methods: {
        selectBtn() {
            if (this.selectType == -1) {
                return
            }
            if (this.selectType == 0) {
                this.$emit('update:selectType', 1)
            } else if (this.selectType == 1) {
                this.$emit('update:selectType', 0)
            }
        },
    },
}
</script>

<style lang="less" scoped>
.dianBox {
    width: 20px;
    height: 20px;
    border-radius: 100px 100px 100px 100px;
    border: 1px solid #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;

    .dianActive {
        width: 12px;
        height: 12px;
        background: #ff4d00;
        border-radius: 50%;
        display: none;
        flex-shrink: 0;
    }

    &.active {
        .dianActive {
            display: block;
        }
    }

    &.unActive {
        .dianActive {
            display: block;
            background: #555555;
        }
    }
}
</style>
